export default {
  subscription: {
    manage: "Abonnement verwalten",
    page_title: "Abonnementverwaltung",
    page_subtitle: "Verwalten Sie Ihre Abonnementeinstellungen und Auto-Verlängerungseinstellungen",
    current_subscription: "Aktuelles Abonnement",
    plan: "Plan",
    billing_cycle: "Abrechnungszyklus",
    status: "Status",
    subscription_control: "Abonnementkontrolle",
    auto_renew_cancelled:
      "Die automatische Verlängerung wurde storniert und der Service wird nach Ablauf am {date} eingestellt.",
    cancel_effect:
      "Die Stornierung Ihres Abonnements tritt nach dem Ende des aktuellen Abrechnungszyklus in Kraft. Ihr Abonnement bleibt bis zum {date} aktiv.",
    restore_prompt:
      "Ihr Abonnement wurde storniert oder wird nach dem Ende des aktuellen Abrechnungszyklus storniert. Um unsere Dienste weiterhin zu nutzen, stellen Sie bitte Ihr Abonnement wieder her.",
    cancel_processing:
      "Ihre Abonnementstornierungsanfrage wird verarbeitet und tritt nach dem Ende des aktuellen Abrechnungszyklus in Kraft.",
    restore_processing: "Ihre Abonnementwiederherstellungsanfrage wird verarbeitet.",
    expired_desc:
      "Ihr Abonnement ist abgelaufen. Bitte aktualisieren Sie Ihre Zahlungsinformationen, um den Service wiederherzustellen.",
    paused:
      "Ihr Abonnement ist derzeit pausiert. Stornierungs- oder Wiederherstellungsvorgänge sind nicht verfügbar.",
    trialing:
      "Sie befinden sich derzeit in der Testphase. Das Abonnement wird nach Ablauf der Testphase automatisch in ein kostenpflichtiges Abonnement umgewandelt.",
    no_action: "Der aktuelle Status Ihres Abonnements unterstützt keine Aktionen.",
    cancel_subscription_btn: "Abonnement stornieren",
    restore_subscription_btn: "Abonnement wiederherstellen",
    restoring: "Wird wiederhergestellt...",
    cancelling: "Wird storniert...",
    status_unavailable: "Status nicht verfügbar",
    no_active_subscription: "Sie haben kein aktives Abonnement",
    choose_plan: "Plan auswählen",
    cancel_modal_title: "Abonnement stornieren",
    cancel_confirm:
      "Sind Sie sicher, dass Sie Ihr Abonnement stornieren möchten? Dies tritt nach dem Ende des aktuellen Abrechnungszyklus ({date}) in Kraft. Danach wird Ihr Abonnement deaktiviert und Sie verlieren den Zugriff auf Premium-Funktionen.",
    reason_label: "Grund (Optional):",
    reason_placeholder: "Bitte teilen Sie uns mit, warum Sie stornieren...",
    status_updated: "Abonnementstatus aktualisiert",
    cancel_request_submitted: "Abonnementstornierungsanfrage eingereicht",
    cancel_failed: "Abonnementstornierung fehlgeschlagen",
    restore_request_submitted: "Abonnementwiederherstellungsanfrage eingereicht",
    restore_failed: "Abonnementwiederherstellung fehlgeschlagen",
    active: "Aktiv",
    canceled: "Storniert",
    cancel_pending: "Stornierung ausstehend",
    restore_pending: "Wiederherstellung ausstehend",
    past_due: "Überfällig",
    paused_status: "Pausiert",
    trialing_status: "Testphase",
    next_cycle_cancel: "Stornierung im nächsten Zyklus",
    unknown_status: "Unbekannter Status",
    monthly: "Monatlich",
    yearly: "Jährlich",
  },
  invoices: {
    recent: "Neueste Rechnungen",
    number: "Rechnungsnummer",
    order_no: "Bestellnummer",
    amount: "Betrag",
    status: "Status",
    created_at: "Erstellt am",
    actions: "Aktionen",
    status_issued: "Ausgestellt",
    status_paid: "Bezahlt",
    status_voided: "Storniert",
    view_all: "Alle Rechnungen anzeigen",
  },
  orders: {
    no: "Bestellnummer",
    plan_type: "Plantyp",
    duration: "Dauer",
    amount: "Betrag",
    status: "Status",
    paid_at: "Bezahlt am",
    created_at: "Erstellt am",
    actions: "Aktionen",
    quantity: "Menge",
    status_pending: "Ausstehend",
    status_paid: "Bezahlt",
    status_failed: "Fehlgeschlagen",
    status_refunded: "Erstattet",
    refund_pending: "Rückerstattung ausstehend",
    refund_failed: "Rückerstattung fehlgeschlagen",
    cancelled: "Storniert",
    expired: "Abgelaufen",
    days: "Tage",
    cancel_confirm: "Sind Sie sicher, dass Sie diese Bestellung stornieren möchten?",
    delete_confirm: "Sind Sie sicher, dass Sie diese Bestellung löschen möchten?",
    downloading_invoice: "Rechnung wird heruntergeladen...",
    download_failed: "Download fehlgeschlagen",
    check_refund: "Rückerstattungsberechtigung wird überprüft...",
    refund_not_eligible: "Nicht für Rückerstattung berechtigt",
    check_refund_failed: "Überprüfung der Rückerstattungsberechtigung fehlgeschlagen",
    prorated_refund_title: "Anteilige Rückerstattung",
    prorated_refund_content:
      "Diese Rückerstattung wird anteilig basierend auf Ihrer Nutzung berechnet.",
    credits_refund_content:
      "Diese Rückerstattung wird anteilig basierend auf den verbleibenden Guthaben berechnet.",
    full_refund_title: "Vollständige Rückerstattung",
    full_refund_content: "Sie sind für eine vollständige Rückerstattung berechtigt.",
    request_refund: "Rückerstattung beantragen",
    processing_refund: "Rückerstattungsanfrage wird verarbeitet...",
    refund_request_failed: "Rückerstattungsanfrage fehlgeschlagen",
    refund_reason: "Grund der Rückerstattung",
    refund_reason_placeholder: "Bitte geben Sie einen Grund für die Rückerstattung an...",
    refund_reason_required: "Grund der Rückerstattung ist erforderlich",
    refund_conditions: "Rückerstattungsbedingungen",
    no_report_generated: "Kein Bericht generiert",
    no_calculations_performed: "Keine Berechnungen durchgeführt",
    no_api_used: "Keine API verwendet",
    subscription_period: "Abonnementzeitraum",
    subscription_details: "Abonnementdetails",
    total_days: "Gesamttage",
    remaining_days: "Verbleibende Tage",
    refund_amount: "Rückerstattungsbetrag",
    refund_reasons: {
      order_not_found: "Bestellung nicht gefunden",
      unauthorized: "Unbefugter Zugriff",
      order_not_completed: "Nur abgeschlossene Bestellungen können zurückerstattet werden",
      subscription_not_found: "Abonnement nicht gefunden",
      paid_features_used:
        "Während des Abonnementzeitraums wurden kostenpflichtige Funktionen verwendet",
      internal_error:
        "Bei der Überprüfung der Rückerstattungsberechtigung ist ein interner Fehler aufgetreten",
    },
    calculation_quota: "Berechnungsguthaben",
    report_quota: "Berichtsguthaben",
    quota_info: "{purchased} {type} gekauft, {used} verwendet, {remaining} verbleibend",
    quota_detail: "{purchased} gekauft, {used} verwendet, {remaining} verbleibend",
    no_credits_used: "Kein Guthaben verwendet",
    refund_requested: "Rückerstattungsanfrage erfolgreich eingereicht",
    refund_pending_approval:
      "Rückerstattungsanfrage eingereicht. Die Rückerstattung steht noch aus und kann einige Zeit zur Verarbeitung benötigen.",
    refund_approved: "Rückerstattung erfolgreich genehmigt",
    refund_rejected: "Die Rückerstattungsanfrage wurde abgelehnt",
    refund_success: "Rückerstattung erfolgreich",
    refund_processing: "Rückerstattung wird verarbeitet",
    refund_success_message:
      "Wir haben Ihre Rückerstattung erfolgreich verarbeitet. Es kann bis zu 5 Werktage dauern, bis das Geld auf Ihrem Konto gutgeschrieben wird.",
    refund_processing_message: "Ihre Rückerstattung wird noch verarbeitet, bitte haben Sie Geduld.",
    checking_order_status: "Bestellstatus wird überprüft...",
  },
};
